<template>
    <div v-if="submission">
        <div class="card card-custom dm-wizard-card">
            <div class="card-body p-0">
                <!-- <TopNavigationByPhase
                    :class="{ 'dm-wizard-navigation-mobile': isMobile }"
                    @reloadNavigation="loadNavigation()"
                /> -->
                <TopNavigation
                    :class="{ 'dm-wizard-navigation-mobile': isMobile }"
                    @reloadNavigation="loadNavigation()"
                />
                <div
                    class="wizard wizard-5 dm-wizard"
                    :class="{
                        'dm-wizard-simple': form_type == 'simple',
                        'dm-wizard-elaborate': form_type == 'elaborate',
                    }"
                    data-wizard-state="between"
                    data-wizard-clickable="false"
                >
                    <div class="dm-wizard-left">
                        <div class="">
                            <div class="div fv-plugins-bootstrap fv-plugins-framework">
                                <div
                                    class="pb-5"
                                    data-wizard-type="step-content"
                                    data-wizard-state="current"
                                >
                                    <h4 class="mb-6 font-weight-bold text-dark">
                                        {{ translate(currentStepName) }}
                                    </h4>

                                    <p
                                        class="mb-8"
                                        v-if="currentStepShortDescription"
                                        v-html="currentStepShortDescription"
                                    >
                                    </p>

                                    <slot></slot>
                                </div>

                                <BottomNavigation />
                            </div>
                        </div>
                    </div>

                    <div
                        class="dm-wizard-right border-bottom border-bottom-lg-0"
                        v-if="form_type == 'elaborate'"
                    >
                        <div class="">
                            <Tooltips />
                        </div>
                    </div>
                </div>

                <div class="alert alert-light mb-0 d-flex align-items-center justify-content-between dm-wizard-discard">
                    <span class="text-dark-75 font-size-xs">{{ translate("Data is automatically saved as you enter it. You can leave any time and come back later. If you want to cancel your submission click “Discard”") }}</span>
                    <DiscardSubmissionButton />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapState, mapWritableState, mapActions } from "pinia";
import Tooltips from "./tooltips/Tooltips.vue";
import TopNavigation from "./top-navigation/TopNavigation.vue";
import BottomNavigation from "./bottom-navigation/BottomNavigation.vue";
import DiscardSubmissionButton from "./partials/DiscardSubmissionButton.vue";

export default {
    components: {
        Tooltips,
        TopNavigation,
        BottomNavigation,
        DiscardSubmissionButton,
    },

    computed: {
        ...mapState(useSubmissionWizardStore, [
            "currentStepName",
            "currentStepShortDescription",
            "form_type",
        ]),
        ...mapWritableState(useSubmissionWizardStore, [
            "is_mobile",
            "company_id",
            "submission_id",
            "current_route_name",
            "presentation",
            "submission",
        ]),
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, ["executeInitialDataLoad"]),
    },

    mounted() {
        this.is_mobile = this.isMobile;
        this.company_id = typeof companyId !== "undefined" ? companyId : null; // companyId is defined in DOM
        this.submission_id = submissionId; // NB: Must exist in the DOM
        this.current_route_name = this.$route.name;

        this.executeInitialDataLoad();
    },
};
</script>
